/**
 * 【法币展示/决策 统一逻辑】CFD 交易对决策（跳转交易时的默认币对）
 * 统一只信 recommendedCurrencyList，不再做本地 balance / fiatCurrencyIds / IP 兜底。
 */
import { getCfdSymbolByIP } from "./getCfdSymbolByIP";
import { getCfdSymbolByFiatCurrencyIds } from "./getCfdSymbolByFiatCurrencyIds";

/**
 * 统一解析 CFD 交易对：法币余额 → fiatCurrencyIds → IP
 * @param {{ fiatCurrencyIds?: number[]; loginStatus?: number }} options
 * loginStatus===1 时才请求 by-balance；未登录调用会 401 触发全局跳转登录
 * @returns {Promise<string>}
 */
export async function resolveCfdSymbol(options = {}) {
  return getCfdSymbolByIP();
}

export { DEFAULT_FIAT_SYMBOL, getCfdSymbolByIP } from "./getCfdSymbolByIP";
export { getCfdSymbolByFiatCurrencyIds } from "./getCfdSymbolByFiatCurrencyIds";
